export default __webpack_public_path__ + "static/media/map-marker.faef582b.svg";